import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const ReCaptcha = ({ onChange }) => {
  return (
    <div className="recaptcha-container">
      <ReCAPTCHA
        sitekey="6LcIEssqAAAAABwB0mlvsGxij3rAIrXFVXTmd2xp" 
        onChange={onChange}       
      />
    </div>
  );
};

export default ReCaptcha;
